module.exports = __webpack_public_path__ + "img/applets1icon4.76c58ff7.png";